import Validator from './Validator';

export default Validator;
